import { createTheme } from "@mui/material/styles";
import { PE } from "../utils/padelEagleBrand";

// MUI theme implementing the Padel Eagle Styleguide & CI 2027 (light only).
export function createPadelEagleTheme() {
  const headings = {
    fontFamily: PE.headingFont,
    fontWeight: 700,
    color: PE.bordeaux,
  };
  return createTheme({
    palette: {
      mode: "light",
      primary: { main: PE.orange, dark: PE.mauve, light: PE.peach, contrastText: "#fff" },
      secondary: { main: PE.bordeaux, dark: PE.mauve, light: PE.oldRose, contrastText: "#fff" },
      success: { main: "#4f8a5b" },
      background: { default: PE.offWhite, paper: PE.white },
      text: {
        primary: PE.mauve,
        secondary: `rgba(${PE.mauveRgb},0.8)`,
        disabled: PE.rose,
      },
      divider: PE.roseLight,
    },
    typography: {
      fontFamily: PE.bodyFont,
      h1: { ...headings },
      h2: { ...headings },
      h3: { ...headings },
      h4: { ...headings },
      h5: { ...headings },
      h6: { ...headings },
      button: { fontFamily: PE.bodyFont, fontWeight: 600, textTransform: "none", fontSize: "1rem" },
    },
    shape: { borderRadius: PE.cardRadius },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: { backgroundColor: PE.offWhite, color: PE.mauve, fontFamily: PE.bodyFont },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: "none", borderRadius: PE.cardRadius },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: { borderRadius: PE.cardRadius, boxShadow: "none", border: `1px solid ${PE.roseLight}` },
        },
      },
      MuiDialog: {
        styleOverrides: { paper: { borderRadius: PE.tileRadius } },
      },
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
          root: { borderRadius: 999, fontWeight: 600, textTransform: "none", paddingInline: 22 },
          sizeSmall: { fontSize: "0.8125rem", paddingInline: 14 },
          containedPrimary: {
            backgroundColor: PE.orange,
            color: "#fff",
            "&:hover": { backgroundColor: PE.mauve },
          },
          containedSecondary: {
            backgroundColor: PE.bordeaux,
            color: "#fff",
            "&:hover": { backgroundColor: PE.mauve },
          },
          outlined: {
            borderColor: PE.bordeaux,
            color: PE.bordeaux,
            "&:hover": { backgroundColor: PE.mauve, color: "#fff", borderColor: PE.mauve },
          },
          outlinedPrimary: {
            borderColor: PE.bordeaux,
            color: PE.bordeaux,
            "&:hover": { backgroundColor: PE.mauve, color: "#fff", borderColor: PE.mauve },
          },
          text: { color: PE.bordeaux, "&:hover": { backgroundColor: `rgba(${PE.mauveRgb},0.08)` } },
        },
      },
      MuiAppBar: {
        defaultProps: { elevation: 0 },
        styleOverrides: {
          colorPrimary: { backgroundColor: PE.bordeaux, color: "#fff", backgroundImage: "none" },
          root: {
            boxShadow: "none",
            "& .MuiButton-root.MuiButton-colorInherit, & .MuiButton-root.MuiButton-colorInherit .MuiButton-startIcon, & .MuiIconButton-colorInherit": {
              color: "#fff",
            },
            "& .MuiButton-colorInherit:hover": { backgroundColor: PE.orange, color: "#fff" },
          },
        },
      },
      MuiChip: {
        styleOverrides: { root: { borderRadius: 999, fontWeight: 600 } },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            "& .MuiOutlinedInput-notchedOutline": { borderColor: PE.roseLight },
            "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: PE.rose },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: PE.bordeaux },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: { root: { "&.Mui-focused": { color: PE.bordeaux } } },
      },
      MuiTabs: {
        styleOverrides: { indicator: { backgroundColor: PE.orange } },
      },
      MuiLink: {
        styleOverrides: { root: { color: PE.bordeaux } },
      },
    },
  });
}
